import { render, staticRenderFns } from "./appoint-accept.vue?vue&type=template&id=02d722a6&scoped=true&"
import script from "./appoint-accept.vue?vue&type=script&lang=js&"
export * from "./appoint-accept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d722a6",
  null
  
)

export default component.exports